import { render, staticRenderFns } from "./userDoc.vue?vue&type=template&id=a951ac4c"
import script from "./userDoc.vue?vue&type=script&lang=js"
export * from "./userDoc.vue?vue&type=script&lang=js"
import style0 from "./userDoc.vue?vue&type=style&index=0&id=a951ac4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports